import { EmailTemplate } from '../../../../../../types/internal-api';

/**
 * Returns partial email options based of the provided email templates.
 *
 * @export
 * @param {EmailTemplate[]} templates
 * @returns
 */
export function emailOptionsFromTemplates(templates: EmailTemplate[]) {
    if (!templates || templates.length === 0) {
        // no changes
        return {};
    }

    const defaultTemplateIndex = templates.findIndex(t => t.isDefault);
    if (defaultTemplateIndex >= 0) {
        return {
            subject: templates[defaultTemplateIndex].subject,
            body: templates[defaultTemplateIndex].body,
            saveSubject: false,
            saveBody: false,
        };
    }

    if (templates.length === 1) {
        // apply the only one
        return {
            subject: templates[0].subject,
            body: templates[0].body,
            saveSubject: false,
            saveBody: false,
        };
    }

    return {
        subject: '',
        body: '',
        saveSubject: false,
        saveBody: false,
    };
}
